// extracted by mini-css-extract-plugin
module.exports = {"root":"Board_root__3wHYE","table":"Board_table__L3DYs","MuiPaper-root":"Board_MuiPaper-root__wRZ4e"};